import React, { useState } from 'react'
import video_instructivo_concurso  from '../../assets/videos/Instructivo Concurso Posgrado de Medicina 2026.mp4'
import ReactPlayer from 'react-player'
import baremoPdf from '../../assets/files/Concurso/BAREMO 2026.pdf'
// import ofertaCuposPdf from '../../assets/files/Concurso/OFERTA DE CUPOS CONCURSO 2025.pdf'

const ConcursoInstructivos = () => {
  const urlInscripcion = 'https://forms.gle/EHc6KogWWwEHTXFc9'

  const baremo = {
    url: baremoPdf,
    fileName: 'BAREMO 2026'
  }

  // const ofertaCupos = {
  //   url: ofertaCuposPdf,
  //   fileName: 'OFERTA DE CUPOS CONCURSO 2025'
  // }

  const [videoReadyStatus, setVideoReadyStatus] = useState(false);
  
  const toggleVideoStatus = () => {
    setVideoReadyStatus(true);
  }

  return (
    <div className='page-section instructivos'>
        <section className='video-container'>
          <div className={`video-canvas ${ videoReadyStatus ? 'ready' : 'loading' }`}>
            <button 
              className={`video-placeholder btn btn-secondary disabled placeholder-wave d-${videoReadyStatus ? 'none' : 'block'}`} 
            ></button>
            <div className={`d-${ videoReadyStatus ? 'block' : 'none' }`}>
              <ReactPlayer
                className='video-player'
                url={video_instructivo_concurso}
                playing={false}
                volume={0.3}
                width={'100%'}
                height={'auto'}
                onReady={toggleVideoStatus}
                controls={true}
              />
            </div>
          </div>
          <div className='button-group d-flex flex-column'>
            <a 
              href={baremo.url} 
              download={baremo.fileName} 
              className='btn-baremo btn btn-primary link-button'
            >
              Baremo 2026
            </a>
            {/* <a 
              href={ofertaCupos.url} 
              download={ofertaCupos.fileName} 
              className='btn-cupos btn btn-primary link-button'
            >
              Oferta de Cupos
            </a> */}
            <a className='btn-cupos btn btn-primary link-button' href={urlInscripcion} target='blank'>
              Formulario de Inscripción
            </a>
          </div>
        </section>

        <section className='info-container'>
          <p className='heading-p'>La División de Estudios para Graduados de la Facultad de Medicina de la Universidad del Zulia, da inicio al Concurso 2026.</p>
          
          {/* <div className='info-group'>
            <h3 className='modal-subtitle continuous'>Publicación del Baremo e Instructivo</h3>
            <p className='info-p'>Lunes 02 de junio de 2025.</p>
          </div> */}

          <div className='info-group'>
            <h3 className='modal-subtitle'>Recepción de Credenciales</h3>
            <p className='info-p'>Desde lunes 13 de abril hasta viernes 10 de julio de 2026.</p>
            {/* <h4 className='highlight-title'>PRÓRROGA:</h4>
            <p className='info-p'>Hasta el jueves 03 de octubre de 2024</p> */}
            <h4 className='highlight-title fw-bold'>Horario: </h4>
            <p className='info-p'>Lunes a viernes</p>
            <p className='info-p'>8:30 AM a 4:00 PM</p>
            <p className='info-p' dangerouslySetInnerHTML={{__html: '<b>Lugar</b>: Edificio Ciencia y Salud de la Facultad de Medicina de LUZ. '}}/>
          </div>
          <div className='info-group'>
            <h3 className='modal-subtitle'>Examen de Conocimientos</h3>
            <p className='info-p'>Sábado 18 de julio de 2026. </p>
            <p className='info-p'>Fecha única a nivel nacional. </p>
            <p className='info-p'>Hora: 8:00 AM</p>
            <p className='info-p' dangerouslySetInnerHTML={{__html: '<b>Lugar</b>: Edificio Ciencia y Salud de la Facultad de Medicina de LUZ. '}}/>
          </div>
        </section>
    </div>
  )
}

export { ConcursoInstructivos }